// TODO: Use more reselect! Create a getQuizSessions selector that can be used for reselecting quiz sessions by id
import { createSelector } from 'reselect';
import QuizSession from '../records/QuizSession';
import { List } from 'immutable';
var path = 'quizSessions';
export var getActiveQuizSession = function getActiveQuizSession(state) {
  return getQuizSessionById(state, getActiveQuizSessionId(state));
};
export var getActiveQuizSessionId = function getActiveQuizSessionId(state) {
  return state.getIn([path, 'activeQuizSessionId']);
};
export var getQuizSessionById = function getQuizSessionById(state, id) {
  return QuizSession.create(state.getIn([path, id]));
};
export var getQuizSessionsByIds = function getQuizSessionsByIds(state) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return ids.reduce(function (list, id) {
    var quizSession = getQuizSessionById(state, id);
    return quizSession ? list.push(quizSession) : list;
  }, List());
};

// Reselect Selectors
export var getBacktrackingIsAllowed = createSelector(getActiveQuizSession, function (activeSession) {
  return activeSession && activeSession.get('allowBacktracking');
});
export var isOneQuestionAtATime = createSelector(getActiveQuizSession, function (activeSession) {
  return activeSession && activeSession.get('oneAtATimeType') === 'question';
});